module.exports = __webpack_public_path__ + "media/customizations/dobsonranch/logo-1b3e224882854fe0244ef282b9b82855.png";